export function resolvePurchasedLoansListPath(investorMember: boolean): string {
  return investorMember ? "/loans/list?tab=14" : "/loans/list?tab=0";
}
